import { EmojiResource } from '@atlaskit/emoji/resource';
import { ProviderFactory } from '@atlaskit/editor-common/provider-factory';

import { getEmojiProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider.ts';
import { createSnippetsRendererMediaProvider } from '@confluence/snippets-media-support/entry-points/SnippetsMediaProvider.ts';

export const getProviders = (cloudId: string, userId: string | null, snippetId: string) => {
	const providers = ProviderFactory.create({});
	providers.setProvider('emojiProvider', getEmojiProvider(EmojiResource, { cloudId, userId }));
	providers.setProvider('mediaProvider', createSnippetsRendererMediaProvider({ snippetId }));
	return providers;
};
